import React from 'react';
import VersionDetailPanel from '../../../detail/VersionDetailPanel';
import SelectForm from '../../../../../components/form/SelectForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import {
  VERSION_DETAIL_PAGE_PANEL_NAME,
  VERSION_DETAIL_PAGE_TYPE,
  VERSION_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/versionConstants';
import './VersionDetailType.scss';

const VersionDetailType = (props) => {
  const { form, setData, data, pageType } = props;
  const { type } = data;

  /**
   * 편집 페이지인 경우
   */
  const isEditPage = pageType === VERSION_DETAIL_PAGE_TYPE.EDIT;

  return (
    <VersionDetailPanel name={VERSION_DETAIL_PAGE_PANEL_NAME.VER_TYPE} className="version-detail-type" title="타입">
      <div className={'panel-body'}>
        {/*타입*/}
        <SelectForm
          label="타입명"
          form={form}
          isTable
          disabled={isEditPage}
          rules={[formRequiredRules(true, '타입을 선택해주세요.', false)]}
          initialValue={type}
          onChange={(value) =>
            setData({
              path: ['versionDetail', 'verType', 'type'],
              value,
            })
          }
          list={VERSION_TYPE_SELECT_LIST}
          name="type"
        />
      </div>
    </VersionDetailPanel>
  );
};

export default VersionDetailType;
